exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ZnWXo{cursor:pointer;background:transparent;border-radius:2px;outline:none;border:1px solid #dedede;height:30px;padding:0 12px;font-size:14px;z-index:10;position:relative}.ZnWXo:hover{background-color:#f3f3f3}._2L0Uv{margin-right:6px}.tVLP0{padding:0 7px;opacity:.6;border:0;height:32px;width:32px;line-height:32px;border-radius:16px}.tVLP0 .grTcg{display:none}.tVLP0 ._2L0Uv{margin-right:0}._2748g.tVLP0,.tVLP0:hover{opacity:1;background-color:#ffd906}", ""]);

// exports
exports.locals = {
	"favourite": "ZnWXo",
	"img": "_2L0Uv",
	"compact": "tVLP0",
	"text": "grTcg",
	"isFavorite": "_2748g"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/Favourite/Favourite.css
// module id = 1743
// module chunks = 15 18 19 20 32 36 37